let $toggles;

$(document).ready(function($) {

    $toggles = $('.js-toggle');

    if( $toggles.length > 0 ) {
        $toggles.each(function() {
            let toggle = $(this);
            let btns = $(this).find('.js-toggle-buttons button');

            btns.on('click', function() {
                $(btns).removeClass('is-active');
                $(this).addClass('is-active');
                
                let link = $(this).attr('data-link');
                if( link ) {
                    toggle.find('.js-toggle-items').removeClass('is-active');
                    toggle.find(`[data-target="${link}"]`).addClass('is-active');
                }
                
            })
        })
    }
    
});
